// extracted by mini-css-extract-plugin
module.exports = {"gridRoundedLabel":"Label_gridRoundedLabel__wtkex"};